import { useContext } from 'react';
import { ConsentActionsContext, ConsentStateContext } from '../contexts/consent.context';
export const useConsentStateContext = () => {
    return useContext(ConsentStateContext);
};
export const useConsentActionsContext = () => {
    return useContext(ConsentActionsContext);
};
export const useConsentContext = () => {
    const stateContext = useConsentStateContext();
    const actionsContext = useConsentActionsContext();
    return {
        ...stateContext,
        ...actionsContext,
    };
};
